<!--eslint-disable vue/no-v-text-v-html-on-component-->
<template>
  <BaseButtonElement
    v-if="editMode || userAuthorCheck"
    v-bind="{...$props, ...$attrs}"
    :handle-custom-click="() => showUnpublishWarning = true"
  />
  <Teleport to="body">
    <iModal
      v-if="showUnpublishWarning"
      :close-on-backdrop="false"
      :close-on-escape="false"
      :close-on-secondary="false"
      :max-width="600"
      :primary-action-button-loading="loadingPublish"
      primary-action-button-label="Unpublish"
      title="Edit Article"
      @close="showUnpublishWarning = false"
      @click:primary="() => unpublishArticle(entityId)"
      @click:secondary="showUnpublishWarning = false"
    >
      <template #body>
        <iParagraph class="modal-body-text">
          Your article is currently live. To edit your article you need to unpublish it. This will remove your article
          from the platforms it is published on until you republish it.
        </iParagraph>
      </template>
    </iModal>
  </Teleport>
</template>

<script>
import {
  ArticleEditorElementMixin,
} from "%/dynamic-component-editor/standard-elements/articles/shared/article-editor-element-mixin";
import {
  ButtonElementMixin,
} from "%/dynamic-component-editor/standard-elements/button-element/button-element-mixin";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import useFanPublicationStore from "%/dynamic-component-editor/stores/fan-publication-store";
import { mapState } from "pinia";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";

export default {
  name: "EditArticleButton",
  components: { BaseButtonElement },
  extends: BaseButtonElement,
  mixins: [ArticleEditorElementMixin, ButtonElementMixin, StoryPageElementMixin],
  inheritAttrs: false,
  elementPanelSettings: {
    displayName: "Edit Article",
    elementGroup: "storyElements",
  },
  data() {
    return {
      showUnpublishWarning: false,
    };
  },
  computed: {
    ...mapState(useConfigurationStore, [
      "canCreateArticle",
    ]),
    ...mapState(useFanPublicationStore, ["userId"]),
    userAuthorCheck() {
      return this.entity && this.entity.authoringUserId === this.userId;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
